<template>
  <article
    class="teaser-text teaser-text--lg-width-33 teaser-text--sm-width-50"
    :class="$themeClass"
  >
    <slot name="beforePicture" />
    <div
      v-click-redirect="{ configPreset: 'teaser-default' }"
      class="teaser-text__picture-wrapper"
      aria-hidden="true"
    >
      <figure v-if="$teaser.image" class="teaser-text__picture">
        <r-image :sources="$teaser.image.sources" :alt="$teaser.image.alt" />
        <div
          v-if="hasPublisher.image"
          class="teaser-text__sticker sticker-logo"
        >
          <r-image
            :sources="$extension.publisher.image.sources"
            :alt="$extension.publisher.image.alt"
          />
        </div>
      </figure>
    </div>
    <div class="teaser-text__content">
      <header class="teaser-text__header">
        <div
          v-if="
            ($extension.overline || hasPublisher.domain) && !hasPublisher.image
          "
          class="teaser-text__label-overline label-overline"
          :class="{ 'label-overline--no-underline': $isExternal }"
        >
          <span v-if="!$isExternal">
            {{ $extension.overline }}
          </span>
          <span v-else-if="hasPublisher.domain">{{
            $extension.publisher.domain
          }}</span>
        </div>
        <span
          v-if="hasPublisher.image && hasPublisher.name"
          class="a-visually-hidden"
        >
          {{ publisherName }}
          <a-label path="renderer.teaser.contribution.singular"></a-label
        ></span>
        <r-heading :level="teaserHeadingLevel" class="teaser-text__heading">
          <r-link
            class="teaser-text__link"
            :url="$teaser.link.url"
            :target="$teaser.link.target"
          >
            {{ $teaser.title }}
          </r-link>
        </r-heading>
        <div
          v-if="$isExternal && !hasPublisher.image"
          class="heading-indicator heading-indicator--teaser"
        >
          <bpb-icon icon="i-link__external--thin" :decorative="true"></bpb-icon>
        </div>
        <bpb-bookmark v-else :item-id="$meta.id"></bpb-bookmark>
      </header>
      <p class="teaser-text__description">
        {{ $teaser.text }}
      </p>
      <footer
        v-if="hasFooter"
        class="teaser-text__footer teaser-text__footer--has-border"
      >
        <p
          v-if="$extension.authors && $extension.authors.length"
          class="teaser-text__author"
        >
          <r-author-names :authors="$extension.authors" />
        </p>
        <p v-if="publishingDate || readingTime" class="teaser-text__timing">
          <time v-if="publishingDate" :datetime="publishingDateTime">{{
            publishingDate
          }}</time>
          <span v-if="readingTime"
            ><span v-if="publishingDate">/</span> {{ readingTime }}
            <a-label
              v-if="readingTime === 1"
              path="readingTime.oneMinute"
              :is-visible="true"
            ></a-label>
            <a-label
              v-else
              path="readingTime.inMinutes"
              :is-visible="true"
            ></a-label>
          </span>
        </p>
      </footer>
    </div>
  </article>
</template>

<script>
import { computedExtensionDefaults } from './extension.mixin.js';

export default {
  mixins: [computedExtensionDefaults],
  inject: {
    teaserHeadingLevel: { default: 3 },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    publisherName() {
      return this.$extension.publisher.name || this.$extension.publisher.domain;
    },
    readingTime() {
      return Math.ceil(this.$extension.estimatedReadingTime / 1000 / 60);
    },
    publishingDate() {
      const publishingDate = new Date(this.$extension.publishingDate * 1000); // multiplied with 1000 to shift UNIX epoch timestamp (in s) to ms as Date expects
      return publishingDate.toLocaleString(this.lang, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
    },
    publishingDateTime() {
      const publishingDate = new Date(this.$extension.publishingDate * 1000);
      const year = publishingDate.getFullYear();
      const month =
        publishingDate.getMonth() > 8
          ? publishingDate.getMonth() + 1
          : '0' + (publishingDate.getMonth() + 1).toString();
      const day =
        publishingDate.getDate() > 9
          ? publishingDate.getDate()
          : '0' + publishingDate.getDate().toString();

      return `${year}-${month}-${day}`;
    },
    hasPublisher() {
      if (!this.$extension.publisher) return false;
      let publisher = {};
      publisher.name = !!this.$extension.publisher.name;
      publisher.domain = !!this.$extension.publisher.domain;
      publisher.image = !!this.$extension.publisher.image;
      return publisher;
    },
    hasFooter() {
      return this.$extension.authors && this.$extension.authors.length;
    },
  },
};
</script>
